export default __webpack_public_path__ + "static/media/640_dummy2016-meditation01-mobile-de.956448cf.png";